import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import LZString from 'lz-string';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { HiOutlineDownload } from 'react-icons/hi';
import BuyerInvoicePrintContent from './BuyerInvoicePrintContent';
import './BuyerInvoicePreviewModal.css';
import '../BuyerInvoice.css';
import TelegramSafeArea from '../../../../Components/TelegramSafeArea';
import Modal from '../../../../Components/Modal/Modal';

export default function BuyerInvoicePreviewModal({ isOpen, onClose, invoiceData }) {
    const printContentRef = useRef(null);
    const transformRef = useRef(null);
    const [isDownloading, setIsDownloading] = useState(false);

    if (!isOpen || !invoiceData) return null;

    const modalTitle = 'پیش‌نمایش فاکتور خرید';

    const handleDownloadPdf = async (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!invoiceData || isDownloading) return;
        setIsDownloading(true);

        try {
            const rawJson = JSON.stringify(invoiceData);
            const compressed = LZString.compressToEncodedURIComponent(rawJson);
            const targetUrl = `${window.location.origin}/print/buyer-invoice?data=${compressed}#data=${compressed}`;

            if (window.Telegram?.WebApp?.openLink) {
                window.Telegram.WebApp.openLink(targetUrl);
            } else {
                window.open(targetUrl, '_blank');
            }

            setTimeout(() => {
                setIsDownloading(false);
            }, 3000);

        } catch (error) {
            console.error('Error opening buyer invoice url:', error);
            alert('متأسفانه در آماده‌سازی فاکتور خطایی رخ داد.');
            setIsDownloading(false);
        }
    };

    return createPortal(
        <div style={{ position: 'relative', zIndex: 2147483000 }}>
            <Modal eventToggle={onClose} isOpen={isOpen} locked={true} fullscreen={true}>
                <div className="buyer-invoice-preview-modal">
                    <TelegramSafeArea style={{ background: '#ffffff', color: '#0f172a' }}>
                        <div className="invoice-safe-area-content">
                            <span className="safe-area-title">صورتحساب</span>
                            <span className="safe-area-subtitle">{modalTitle}</span>
                        </div>
                    </TelegramSafeArea>

                    <div className="nc-topbar invoice-topbar">
                        <div className="nc-title">
                            <span>{modalTitle}</span>
                        </div>

                        <div className="invoice-topbar-actions">
                            <button
                                type="button"
                                className="btn-invoice-download"
                                onClick={handleDownloadPdf}
                                disabled={isDownloading}
                                title="دانلود PDF"
                            >
                                {isDownloading ? (
                                    <span className="modal-spinner"></span>
                                ) : (
                                    <>
                                        <HiOutlineDownload size={19} />
                                        <span>دانلود PDF</span>
                                    </>
                                )}
                            </button>

                            <div className="nc-back" onClick={onClose} title="بازگشت">
                                <IoMdArrowRoundBack size={24} />
                            </div>
                        </div>
                    </div>

                    <div className="invoice-preview-scroll-content" style={{ overflow: 'hidden', padding: 0 }}>
                        <TransformWrapper
                            ref={transformRef}
                            initialScale={1}
                            minScale={1}
                            maxScale={4}
                            centerOnInit={true}
                            wheel={{ disabled: true }}
                            pinch={{ step: 5 }}
                            doubleTap={{ step: 1.2, mode: 'toggle' }}
                        >
                            <TransformComponent
                                wrapperStyle={{
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start'
                                }}
                                contentStyle={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <div className="invoice-paper-wrapper" style={{ margin: '16px auto' }}>
                                    <BuyerInvoicePrintContent invoiceData={invoiceData} contentRef={printContentRef} />
                                </div>
                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            </Modal>
        </div>,
        document.body
    );
}
